export var paymentValidationMessages = {
    cardNumber: {
        digitsOnly: "Please enter numbers only for the card number.",
        minLength: "Your card number should be at least 15 digits long.",
        maxLength: "Your card number can be up to 16 digits long.",
    },
    expirationMonth: {
        digitsOnly: "Please use numbers only for the expiration month..",
        invalidMonth: 'Enter a valid month between "01" and "12".',
        exactLength: "Use a 2-digit format for the month (for example, 03).",
    },
    expirationYear: {
        digitsOnly: "Please use numbers only for the expiration year.",
        exactLength: "Enter the expiration year using 4 digits.",
    },
    securityCode: {
        digitsOnly: "Please enter numbers only for the security code.",
        minLength: "The security code is usually at least 3 digits.",
        maxLength: "The security code can be up to 4 digits.",
    },
    cardholderName: {
        invalidName: "Please enter the name exactly as it appears on the card — letters, spaces, periods and hyphens only.",
        minLength: "Please enter at least two characters for the cardholder name field."
    }
};
export var paymentValidationRules = {
    cardNumber: {
        minLength: 15,
        maxLength: 16,
    },
    expirationMonth: {
        length: 2,
        validValues: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
        ],
    },
    expirationYear: {
        length: 4,
    },
    securityCode: {
        minLength: 3,
        maxLength: 4,
    },
    cardholderName: {
        minLength: 2
    }
};
export var isAllDigits = function (value) {
    if (value.length === 0)
        return true;
    for (var i = 0; i < value.length; i += 1) {
        var code = value.charCodeAt(i);
        if (code < 48 || code > 57)
            return false;
    }
    return true;
};
export var isValidCardName = function (value) {
    if (value.length === 0)
        return true;
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var char = value_1[_i];
        if (char === " " || char === "-" || char === ".")
            continue;
        if (char.toLowerCase() !== char.toUpperCase())
            continue;
        return false;
    }
    return true;
};
export var isValidMonth = function (value) {
    return paymentValidationRules.expirationMonth.validValues.includes(value);
};
export var validatePaymentField = function (field, value) {
    switch (field) {
        case "cardNumber": {
            var rules = paymentValidationRules.cardNumber;
            var messages = paymentValidationMessages.cardNumber;
            if (!isAllDigits(value))
                return messages.digitsOnly;
            if (value.length < rules.minLength)
                return messages.minLength;
            if (value.length > rules.maxLength)
                return messages.maxLength;
            return null;
        }
        case "expirationMonth": {
            var rules = paymentValidationRules.expirationMonth;
            var messages = paymentValidationMessages.expirationMonth;
            if (!isAllDigits(value))
                return messages.digitsOnly;
            if (!isValidMonth(value))
                return messages.invalidMonth;
            if (value.length !== rules.length)
                return messages.exactLength;
            return null;
        }
        case "expirationYear": {
            var rules = paymentValidationRules.expirationYear;
            var messages = paymentValidationMessages.expirationYear;
            if (!isAllDigits(value))
                return messages.digitsOnly;
            if (value.length !== rules.length)
                return messages.exactLength;
            return null;
        }
        case "securityCode": {
            var rules = paymentValidationRules.securityCode;
            var messages = paymentValidationMessages.securityCode;
            if (!isAllDigits(value))
                return messages.digitsOnly;
            if (value.length < rules.minLength)
                return messages.minLength;
            if (value.length > rules.maxLength)
                return messages.maxLength;
            return null;
        }
        case "cardholderName": {
            if (!isValidCardName(value))
                return paymentValidationMessages.cardholderName.invalidName;
            return null;
        }
        default:
            return null;
    }
};
